<template>
  <div class="section px-5 md:px-0 md:section-md events" id="events" :style="containerStyle(data.style)">
    <List v-if="$mq=='sm'" :header="data.title" :items="events" image="image_url" title="title" info="excerpt" filter="id" url="url" :search="true" type="event" :share="true" />

    <div v-else>
      <div class="flex justify-between items-center px-8 py-4 mx-auto mt-8 mb-6 w-full"  :style="textStyle('title', data.style)" :class="titleClassSize(data.style)">
        <h3 :class="titleClassSize(data.style)" v-if="view == 'grid'">Events</h3>
        <h3 :class="titleClassSize(data.style)" v-if="view == 'list'">Programme</h3>
        <div class="switch_view" @click="toggleView()">
           <span v-if="view == 'list'">View all Events</span>
           <span v-else>Switch to Programme</span>
        </div>
      </div>
      
      <div class="grid_container overflow-scroll" style="max-height: 450px"  v-if="view == 'grid'">
        <div class="event_grid_options" style="max-width: 75%; margin: 30px auto 10px;">
          <div class="event_search">
            <div v-for="filter in search.filters" :key="filter" class="search_filter" :style="{background: filter.color}" :class="{plainTag: filter.color == null}" @click="setFilter(filter)">
              {{filter.name}}
            </div>
            <div v-if="search.date" class="search_filter date" @click="setDate(date)">{{ formatSearchDate(search.date) }}</div>
            <input class="p-3 rounded-full" v-model="search.text" placeholder="search" />
          </div>
          <div class="popup">
            <div class="glyph filters" :class="{'active': popup == 'filters'}" @click="activePopup('filters')"></div>
            <transition name="fade">
            <div class="popup_container" v-if="popup == 'filters'">
              <p class="popup_title">Filters</p>
              <ul>
                <li v-for="filter in filters" :key="filter.name" @click="setFilter(filter)" :class="{'active': isActiveFilter(filter) > -1}">
                  <span class="tag_marker" :style="{background: filter.color}"></span>
                  {{filter.name}}
                </li>
              </ul>
            </div>
            </transition>
          </div>
          <div class="popup">
            <div class="glyph calendar" :class="{'active': popup == 'calendar'}" @click="activePopup('calendar')"></div>
            <transition name="fade">
              <div class="popup_container calendar_container"  v-if="popup == 'calendar'">
                <Calendar v-if="isView('calendar')  && events.length" :dates="dataReverse" :stylesheet="data.style" :items="events" :filters="filters" :globalStyle="globalStyle" />
              </div>
            </transition>
          </div>
        </div>
      <div class="grid_content">
        <div v-for="item in filteredItems" class="event_box_container" :key="item.id">
          <div class="event_box_title">
            <a :href='item.url' target="_blank" :style="textStyle('paragraph', data.style)">{{item.title}}</a>
          </div>
          <div class="event_box_info" v-if="data.confirm" :class="{confirmed: getTags(item).includes('confirmed')}">
            <span v-if="getTags(item).includes('confirmed')">Confirmed </span><span v-else>Proposed by <a :href="item.author.url" target="_blank">@{{item.author.username}}</a></span><span v-if="item.event" class="ml-1"> for <span class="font-bold">{{formatDate(item.event.start)}}</span> at <span class="font-bold">{{formatTime(item.event.start)}}</span></span>
          </div>
          <div class="event_box_date" v-if="item.event && !data.confirm">
            <b>{{formatDate(item.event.start)}}</b> at <b>{{formatTime(item.event.start)}}</b>
          </div>
          <div class="event_box_image" v-if="item.image_url" :style="{background: 'url(' + item.image_url + ')'}">
          </div>
          <p>{{item.excerpt.substring(0, 400)}}</p>
          <div class="event_box_tags" v-if="getTags(item).length">
            <div v-for="tag in getTags(item)" :key="tag" class="event_tag" :style="{background: getTag(tag).color}" :class="{plainTag: getTag(tag).color == null}" @click="setFilter(getTag(tag))">
              {{getTag(tag).name}}
            </div>
          </div>
          <div class="event_box_meta overflow-scroll">
            <a class="event_box_conversation" :href="item.url" target="_blank">
              Discussion
              <span v-if="item.reply_count != 0">({{item.reply_count}})</span>
            </a>

            <a class="event_box_likes" :href="item.url" target="_blank" v-if="item.like_count != 0">
              {{item.like_count}} 
            </a>
          </div>
          
      </div>
      </div>
      </div>

      <div class="flex bg-gray-100 border mx-auto rounded-lg overflow-hidden" style="max-width: 75%;" v-if="view == 'list'">
      <Timeline :custom="data" :filters="filters" :globalStyle="globalStyle" :items="events" />
      <div class="w-full flex flex-col border-l events_sidebar">
        <Search v-if="isView('search') || $mq == 'sm'" :stylesheet="data.style" :globalStyle="globalStyle"/>
        <Calendar v-if="isView('calendar')  && events.length" :dates="dataReverse" :stylesheet="data.style" :items="events" :filters="filters" :globalStyle="globalStyle" />
        <Filters v-if="isView('filter') && events.length" class="pb-10" :stylesheet="data.style" :items="events" :filters="filters" :globalStyle="globalStyle" />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import List from "@/components/ui/List.vue";
import Timeline from "@/components/ui/Timeline.vue";
import Calendar from "@/components/ui/Calendar.vue";
import Search from "@/components/ui/Search.vue";
import Filters from "@/components/ui/Filters.vue";
import { bus } from '@/main';

export default {
  props: ["data", "stylesheet", "baseUrl", "globalStyle"],
  data() {
    return {
      view: 'grid',
      events: [],
      popup: '',
      filters: [],
      search: {
        text: '',
        filters: [],
        date: null
      }
    };
  },
   components: {
    List,
    Timeline,
    Calendar,
    Search,
    Filters
  },
  methods: {
    activePopup(value) {
      if (this.popup == value) {
        this.popup = ''
      } else {
        this.popup = value
      }
    },
    toggleView() {
      if (this.view == 'grid') {
        this.view = 'list'
      } else {
        this.view = 'grid'
      }
    },
    titleObj() {
      var titleObj = {
        maxWidth: ''
      };
      if (this.stylesheet && this.stylesheet.wrapper) {
        titleObj["maxWidth"] = this.stylesheet.title;
      };
      if (this.data.style && this.data.style.wrapper) {
        titleObj["maxWidth"] = this.data.style.title;
      };
      return titleObj;
    },
    isView(type) {
      if (this.$mq == "md") {
        return true
      } else {
        if (this.view == type) {
          return true
        } else {
          return false
        }
      }
    },
    selectView(type) {
      if (this.view == type) {
        if (this.view == 'calendar') {
          bus.$emit('clearDate', null);
        }
        this.view = null;
      } else {
        this.view = type;
        if (type == 'calendar') {
          bus.$emit('clearType', null);
          bus.$emit('clearSearch', null);
          bus.$emit('clearDate', null);
        }
        if (type == 'filter') {
          bus.$emit('clearSearch', null);
          bus.$emit('clearType', null);
          bus.$emit('clearDate', null);
        }
        if (type == 'search') {
          bus.$emit('clearType', null);
          bus.$emit('clearDate', null);
        }
      }
    },
    getEventTags(events) {
      var array = [];
      events.map(obj => {
        return obj.tags.map(tag => {
          if (!array.includes(tag.name) && this.data.filters[tag.name]) {
            array.push(tag.name)
          }
        });
      });
      return array;
    },
    getTags(obj) {
      var array = [];
      obj.tags.map(tag => {
        if (!array.includes(tag.name) && this.data.filters[tag.name]) {
          array.push(tag.name)
        }
      });
      return array;
    },
    getTag(value) {
      return this.filters.filter(obj => obj.name == value)[0]
    },
    getEventFilters(){
      var colors = ["turquoise", "yellow", "red"]
      var tags = this.getEventTags(this.events);
      var array = [];
      var i;
      
      for (i = 0; i < tags.length; i++) { 
        var obj = {
          name: tags[i],
          color: this.data.filters[tags[i]] || colors[i]
        }
        array.push(obj)
      }      

      this.filters = array;
    },
    getEvents(tag) {
      axios.get(
        `${this.baseUrl}/webkit_components/topics.json?serializer=event&tags=${tag}&per=500`
      ).then(({ data }) => {
        this.events = data;
        this.getEventFilters();
      });
    },
    isActiveFilter(obj){
      return this.search.filters.findIndex(tag => tag.name == obj.name);
    },
    setFilter(obj) {
      var index = this.isActiveFilter(obj);
      if (index > -1) {
          this.search.filters.splice(index, 1);
      }
      else {
        this.search.filters.push(obj)
      }
      this.popup = '';
    },
    setDate(value) {
      if (this.date == value) {
        this.search.date = null;
        bus.$emit('clearDate', null);
      } else {
        this.search.date = value
      }
      this.popup = '';
    },
    formatDate(value) {
      return moment(value).format("dddd MMMM Do");
    },
    formatTime(value) {
      return moment(value).format("HH:mm");
    },
    formatSearchDate(value) {
      return moment(value).format("DD MMMM YYYY");
    },
  },
  created() {
    this.getEvents(this.data.tag);
    bus.$on('setFilterDate', (data) => {
      this.setDate(data);
    })
    bus.$on('clearDate', (data) => {
      this.search.date = data
    })
  },
  computed: {
   filteredItems() {
    let filtered = this.events;

    if (this.search.date != null) {
      filtered = filtered.filter(e => e.event && e.event.start == this.search.date);
    }

    if (this.search.text != "") {
      filtered = filtered.filter(e => e.title.toLowerCase().includes(this.search.text.toLowerCase()) || e.excerpt.toLowerCase().includes(this.search.text.toLowerCase()))
    }

    if (this.search.filters.length > 0) {
      var self = this;
      var filters = this.search.filters.map(obj => obj.name);
      var filter = filtered.filter(function(obj) {
        var tags = self.getTags(obj);
        var tag_filter = tags.filter(value => filters.includes(value));
        if (tag_filter.length) {
          return obj
        }
      })

      filtered = filter;
    }

    return filtered
    }
  }
};
</script>
<style lang="scss" scoped>
.events_sidebar {
  background: rgba(0,0,0,0.01);
  border-radius: 0 10px 10px 0;
  padding: 30px 20px 0 20px;
}
.events_title {
    @apply text-2xl font-bold;

  padding: 20px 30px !important;
}
</style>